export const token = (state) => { return state.token };

export const profile = (state) => { return state.profile };

export const OTPFlag = (state) => { return state.OTPFlag };

export const errors = (state) => { return state.errors };

